export default __webpack_public_path__ + "static/media/CODIGOVOUCHER.2869ad39.png";